import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_staff/settings/contracting-corporation-profile/",
)({
  beforeLoad() {
    throw redirect({
      to: "/settings/contracting-corporation-profile/corporate-overview",
    });
  },
});
